module.exports = __webpack_public_path__ + "media/St 4-keyboard-incorrect.f174f7aa.wav";